"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VALIDATION_REGEXP = void 0;

var _react = _interopRequireWildcard(require("react"));

var _eyeClosed = _interopRequireDefault(require("../../assets/img/icons/eye-closed.svg"));

var _eyeOpened = _interopRequireDefault(require("../../assets/img/icons/eye-opened.svg"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _calendar = _interopRequireDefault(require("./calendar"));

var _calendarHelpers = require("./calendar/calendarHelpers");

var _autocomplete = _interopRequireDefault(require("./email/autocomplete"));

var _styles = require("./styles");

var _excluded = ["type", "value", "errorMessage", "required", "autoComplete", "className", "minDate", "maxDate", "placeholder", "emailDomains", "description", "tooltipText", "minLength"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VALIDATION_REGEXP = {
  name: /[0-9!"№;%:?*()_+=~[\]`@#$^&{},.<>/|\\']/,
  cyrillicName: /^([а-яёА-ЯЁ]+[-']?[а-яёА-ЯЁ]*\s??){0,5}$/,
  password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[^*а-яА-ЯёЁ"@№;$%:^<>|=&+?~`(){},]{8,50}$/,
  agreement: /\b([A-z0-9]){5,16}\b/,
  email: /^[a-z0-9._+-]+@[a-z0-9.-]+\.[a-z]{2,64}/i,
  phone: /^((\+7|7|8)+([0-9]){10})$/,
  login: /[a-z0-9]+/i,
  amount: /^(0|[1-9]\d*)(\.\d{0,2})?$/,
  integer: /^[+-]?\d+$/i,
  date: /(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])/,
  passportSeries: /([0-9]){4}/i,
  passportNumber: /([0-9]){6}/i,
  passportFull: /\d{4}\d{6}/i,
  card: /([0-9]){4}/i,
  mac: /^([0-9A-Fa-f]{12})$/
};
exports.VALIDATION_REGEXP = VALIDATION_REGEXP;
var MASK = {
  phone: '+{7}(000)000-00-00',
  date: '00.00.0000',
  amount: VALIDATION_REGEXP.amount,
  passportSeries: '00 00',
  passportNumber: '000000',
  passportFull: '0000 000000',
  card: '0000',
  mac: '**:**:**:**:**:**'
};

var Input = /*#__PURE__*/function (_PureComponent) {
  _inherits(Input, _PureComponent);

  var _super = _createSuper(Input);

  // Added as a component property
  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this, props); // Set the default state immediately

    _defineProperty(_assertThisInitialized(_this), "checkDate", function (value) {
      var _this$props = _this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate;
      var isValid = true,
          isValidMin,
          isValidMax;
      var valueDate = new Date(value);

      if (minDate) {
        var minD = new Date(minDate);
        isValidMin = valueDate > minD;
        isValid = isValidMin;
      }

      if (maxDate) {
        var maxD = new Date(maxDate);
        isValidMax = valueDate < maxD;
        isValid = isValidMin ? isValidMin && isValidMax : isValidMax;
      }

      return isValid;
    });

    _defineProperty(_assertThisInitialized(_this), "validate", function (value) {
      // TODO: Требуется рефакторинг этой пачки if/else, а лучше всего компонента
      // eslint-disable-next-line sonarjs/cognitive-complexity
      return new Promise(function (resolve) {
        var _this$props2 = _this.props,
            type = _this$props2.type,
            min = _this$props2.min,
            max = _this$props2.max,
            required = _this$props2.required,
            validationRegexp = _this$props2.validationRegexp;
        var hasError = _this.state.hasError;
        var validator = validationRegexp ? new RegExp(validationRegexp) : VALIDATION_REGEXP[type];

        if (validator !== undefined) {
          var invalid = type === 'name' ? validator.test(value) : !validator.test(value);

          if (min && Number(value) < min || max && Number(value) > max) {
            invalid = true;
          }

          if (!required && value === '') {
            invalid = false;
          }

          if (type === 'name' && required && value === '') {
            invalid = true;
          }

          if (type === 'date') {
            invalid = invalid || !_this.checkDate(value);
          }

          if (hasError !== invalid) {
            _this.setHasError(!hasError).then(function (res) {
              resolve(res);
            });
          } else {
            resolve(!hasError);
          }
        } else {
          resolve(true);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "check", function (value) {
      return new Promise(function (resolve) {
        if (value !== undefined) {
          _this.setTouched(true);

          _this.validate(value).then(function (res) {
            resolve(res);
          });
        } else {
          resolve(true);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setTouched", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      _this.setState({
        touched: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setHasError", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return new Promise(function (resolve) {
        _this.setState({
          hasError: value
        }, function () {
          resolve(!value);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setShowError", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.setState({
        showErrorText: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyPress", function (event, regexpToReplace, replaceTo, convertFunc) {
      if (event.which === 13) {
        _this.setState({
          tempValue: null
        });

        var value = _this.getValue(event, regexpToReplace, replaceTo, convertFunc);

        _this.check(value).then(function (isValid) {
          if (isValid) {
            _this.setPrettyText(value);

            _this.props.onChange(value);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "showText", function (value) {
      _this.setState({
        showText: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function (event, regexpToReplace, replaceTo, convertFunc) {
      _this.toggleFocus();

      if (_this.state.noBlurValidation) {
        return;
      }

      var value = _this.getValue(event, regexpToReplace, replaceTo, convertFunc);

      _this.check(value).then(function (isValid) {
        if (isValid) {
          _this.setPrettyText(value);

          _this.setState({
            inputVal: value
          });
        } else {
          _this.setState({
            inputVal: null
          });
        }

        _this.setShowError(_this.state.hasError);
      }).then(function () {
        _this.props.onBlur(event, value);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getValue", function (event, regexpToReplace, replaceTo, convertFunc) {
      var type = _this.props.type;
      var value = _this.mask && type !== 'date' ? _this.mask.unmaskedValue : event.target.value;

      if (regexpToReplace) {
        value = value.replace(regexpToReplace, replaceTo ? replaceTo : '');
      }

      if (!_this.mask && type !== 'date') {
        value = value.replace(/(^\s*)/gi, '').replace(/[ ]{2,}/gi, ' ');
      }

      if (convertFunc) {
        value = convertFunc(value);
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "change", function (event, regexpToReplace, replaceTo, convertFunc) {
      var type = _this.props.type;

      if (_this.mask) {
        _this.mask.updateValue();
      }

      _this.setState({
        tempValue: event.target.value
      });

      var value = _this.getValue(event, regexpToReplace, replaceTo, convertFunc);

      _this.setShowError();

      _this.check(value).then(function (isValid) {
        if (isValid || type !== 'date') {
          _this.props.onChange(value);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPaste", function (event) {
      if (_this.mask) {
        var masked = _this.mask.masked;
        var text = event.clipboardData.getData('text');
        masked.value = text;

        _this.props.onChange(masked.unmaskedValue);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setPrettyText", function (value) {
      var type = _this.props.type;

      if (value && type === 'date') {
        var dateArr = value.split('-');
        var prettyText = null;
        var date = new Date(value);

        if (date) {
          prettyText = "".concat(dateArr[2], " ").concat(_calendarHelpers.CALENDAR_MONTHS_FOR_DATE[dateArr[1] - 1], " ").concat(dateArr[0]);
        }

        _this.setState({
          prettyText: prettyText
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "hidePretty", function () {
      _this.setState({
        prettyText: null
      });

      _this.inputRef.current.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "setTempValue", function (value) {
      var date = new Date(value);
      var showDate = (0, _calendarHelpers.getDateToShow)(date);

      _this.setPrettyText(value);

      _this.setState({
        tempValue: showDate,
        inputVal: value,
        showHelper: false
      }, function () {
        if (_this.mask) {
          _this.mask.updateValue();

          _this.check(value);

          _this.props.onChange(value);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFocus", function () {
      _this.setState(function (prevState) {
        return {
          isFocused: !prevState.isFocused
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showHelper", function (e, def) {
      e.stopPropagation();
      var showHelper = _this.state.showHelper;
      var show = def || !showHelper;

      _this.setState({
        showHelper: show
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideHelper", function (e) {
      var showHelper = _this.state.showHelper;
      showHelper ? _this.showHelper(e, false) : null;
    });

    _defineProperty(_assertThisInitialized(_this), "onEmailSelect", function (value) {
      _this.check(value).then(function (isValid) {
        _this.setShowError(_this.state.hasError);

        _this.pushOnChangeEvent(value);

        _this.setState({
          inputVal: isValid ? value : null,
          tempValue: value
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setContainerRef", function (el) {
      _this.containerRef = el;
    });

    _defineProperty(_assertThisInitialized(_this), "setNoBlurValidation", function () {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.setState(function () {
        return {
          noBlurValidation: val
        };
      });
    });

    _this.state = _objectSpread({}, Input.defaultComponentState);
    _this.inputRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  _createClass(Input, [{
    key: "resetStateWithUpdates",
    value: function resetStateWithUpdates() {
      var _this2 = this;

      var stateUpdates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // Rest operators ensure a new object with merged properties and values.
      // Requires the "transform-object-rest-spread" Babel plugin
      this.setState(_objectSpread(_objectSpread({}, Input.defaultComponentState), stateUpdates), function () {
        if (_this2.mask) {
          _this2.mask.value = '';

          _this2.mask.updateValue();
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var _this$props3 = this.props,
          value = _this$props3.value,
          type = _this$props3.type,
          defaultValue = _this$props3.defaultValue,
          lazyMask = _this$props3.lazyMask;
      this.validate(value);
      this.showText(type !== 'hidden' && !['password', 'fakePassword'].includes(type));
      var input = this.inputRef.current;
      var mask = MASK[type];

      if (input && mask) {
        Promise.resolve().then(function () {
          return _interopRequireWildcard(require('imask'));
        }).then(function (_ref) {
          var IMask = _ref["default"];
          _this3.mask = new IMask(input, {
            mask: mask,
            lazy: lazyMask,
            prepare: function prepare(added, masked) {
              if (_this3.props.type === 'phone' && added === '8' && masked.value === '') {
                return '';
              }

              return added;
            }
          });

          _this3.mask.alignCursor();
        });

        if (type === 'date') {
          if (window) {
            window.addEventListener('click', this.hideHelper);
          }

          this.setTempValue(defaultValue);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var type = this.props.type;

      if (this.mask && this.mask.destroy) {
        this.mask.destroy();
      }

      if (type === 'date') {
        window.removeEventListener('click', this.hideHelper);
      }
    } // если есть minDate или maxDate, после выбора даты возможен ввод, нужно проверить значение

  }, {
    key: "pushOnChangeEvent",
    value:
    /**
     * Force onchange event on the input after email autocompletion form is closed
     * @param {String} value
     */
    function pushOnChangeEvent(value) {
      if (!value) {
        return;
      }

      var input = this.inputRef.current;
      var valueSetter = Object.getOwnPropertyDescriptor(input, 'value').set;
      var prototype = Object.getPrototypeOf(input);
      var prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

      if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(input, value);
      } else {
        valueSetter(input, value);
      }

      input.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }, {
    key: "render",
    value: // TODO: Требуется рефакторинг этой пачки if/else, а лучше всего компонента
    // eslint-disable-next-line sonarjs/cognitive-complexity
    function render() {
      var _this4 = this,
          _ref2;

      // attrs - стандартные атрибуты
      var _this$props4 = this.props,
          type = _this$props4.type,
          value = _this$props4.value,
          errorMessage = _this$props4.errorMessage,
          required = _this$props4.required,
          _this$props4$autoComp = _this$props4.autoComplete,
          autoComplete = _this$props4$autoComp === void 0 ? 'off' : _this$props4$autoComp,
          className = _this$props4.className,
          minDate = _this$props4.minDate,
          maxDate = _this$props4.maxDate,
          placeholder = _this$props4.placeholder,
          emailDomains = _this$props4.emailDomains,
          description = _this$props4.description,
          _this$props4$tooltipT = _this$props4.tooltipText,
          tooltipText = _this$props4$tooltipT === void 0 ? '' : _this$props4$tooltipT,
          _this$props4$minLengt = _this$props4.minLength,
          minLength = _this$props4$minLengt === void 0 ? -1 : _this$props4$minLengt,
          attrs = _objectWithoutProperties(_this$props4, _excluded);

      var _this$state = this.state,
          touched = _this$state.touched,
          hasError = _this$state.hasError,
          showText = _this$state.showText,
          showErrorText = _this$state.showErrorText,
          prettyText = _this$state.prettyText,
          tempValue = _this$state.tempValue,
          inputVal = _this$state.inputVal,
          showHelper = _this$state.showHelper,
          isFocused = _this$state.isFocused;
      var icon = null;
      var inputType = type || 'text';
      attrs.minLength = minLength;

      attrs.onChange = function (event) {
        return _this4.change(event);
      };

      if (type === 'phone' && MASK[type]) {
        attrs.onKeyUp = function (event) {
          return _this4.change(event);
        };
      }

      attrs.onBlur = function (event) {
        return _this4.blur(event);
      };

      switch (type) {
        case 'amount':
          inputType = 'tel';

          attrs.onChange = function (event) {
            return _this4.change(event, /,/g, '.');
          };

          attrs.onBlur = function (event) {
            return _this4.blur(event, /,/g, '.');
          };

          break;

        case 'date':
          inputType = 'text';

          attrs.onChange = function (event) {
            return _this4.change(event, null, null, _calendarHelpers.convertDate);
          };

          attrs.onBlur = function (event) {
            return _this4.blur(event, null, null, _calendarHelpers.convertDate);
          };

          attrs.onKeyPress = function (event) {
            return _this4.onKeyPress(event, null, null, _calendarHelpers.convertDate);
          };

          icon = /*#__PURE__*/_react["default"].createElement(_styles.CalendarIcon, {
            onClick: function onClick(e) {
              return _this4.showHelper(e);
            }
          });
          break;

        case 'phone':
        case 'integer':
          inputType = 'tel';

          attrs.onChange = function (event) {
            return _this4.change(event, /\D/g);
          };

          break;

        case 'hidden':
        case 'fakePassword':
        case 'password':
          inputType = showText ? 'text' : type === 'fakePassword' ? 'text' : 'password';
          icon = /*#__PURE__*/_react["default"].createElement(_styles.Eye, {
            alt: 'Скрыть/Показать',
            src: showText ? _eyeOpened["default"] : _eyeClosed["default"],
            open: showText,
            onTouchStart: function onTouchStart() {
              return _this4.showText(!showText);
            },
            onClick: function onClick() {
              return _this4.showText(!showText);
            }
          });

          attrs.onChange = function (event) {
            return _this4.change(event, /\s/ig);
          };

          break;

        case 'agreement':
          inputType = 'text';
          attrs.maxLength = 16;
          break;

        case 'email':
        case 'login':
          attrs.onChange = function (event) {
            return _this4.change(event, /[а-яё ]/ig);
          };

          break;

        default:
          break;
      }

      var hasMask = this.mask && this.mask.masked.unmaskedValue;
      var emptyValue = !(hasMask || this.inputRef.current && this.inputRef.current.value || value);
      var valueLengthGreaterThanMin = required ? !emptyValue && ((_ref2 = tempValue || value) === null || _ref2 === void 0 ? void 0 : _ref2.length) >= minLength : true;
      var valid = touched && !hasError && (!emptyValue && !required || !emptyValue && required);
      var notValid = touched && (required && emptyValue || hasError || !valueLengthGreaterThanMin);
      var error = errorMessage && showErrorText ? /*#__PURE__*/_react["default"].createElement(_styles.InputError, {
        show: notValid
      }, errorMessage) : null;
      var pretty = prettyText ? /*#__PURE__*/_react["default"].createElement(_styles.PrettyText, {
        onClick: this.hidePretty
      }, prettyText) : null;
      return /*#__PURE__*/_react["default"].createElement(_styles.InputContainer, {
        className: className,
        ref: this.setContainerRef
      }, /*#__PURE__*/_react["default"].createElement(_styles.StyledInput, _extends({
        ref: this.inputRef,
        value: tempValue || value,
        type: inputType,
        notValid: notValid,
        valid: valid,
        onKeyPress: this.onKeyPress,
        onPaste: this.onPaste,
        onFocus: this.toggleFocus,
        showText: showText,
        required: required,
        autoComplete: autoComplete,
        pretty: pretty,
        placeholder: isFocused || value ? '' : placeholder,
        isHasMask: hasMask,
        isIconExist: icon,
        "data-test": "input",
        open: showText
      }, attrs)), pretty, tooltipText ? /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
        position: "bottom",
        arrow: "center",
        parent: /*#__PURE__*/_react["default"].createElement(_styles.QuestionIcon, {
          onClick: this.showHelper
        }),
        stateful: true
      }, tooltipText) : icon, error, description && /*#__PURE__*/_react["default"].createElement(_styles.DescriptionBlock, null, description), type === 'date' && /*#__PURE__*/_react["default"].createElement(_calendar["default"], {
        showCalendar: showHelper,
        onChange: this.setTempValue.bind(this),
        nowDate: inputVal,
        minDate: minDate,
        maxDate: maxDate,
        "data-test": "calendar"
      }), type === 'email' && /*#__PURE__*/_react["default"].createElement(_autocomplete["default"], {
        value: value,
        handleSelect: this.onEmailSelect,
        setNoBlurValidation: this.setNoBlurValidation,
        parentRef: this.containerRef,
        domains: emailDomains,
        "data-test": "autocomplete"
      }));
    }
  }]);

  return Input;
}(_react.PureComponent);

_defineProperty(Input, "defaultProps", {
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onKeyUp: function onKeyUp() {},
  lazyMask: true
});

_defineProperty(Input, "defaultComponentState", {
  hasError: false,
  showErrorText: false,
  touched: false,
  showText: true,
  prettyText: false,
  tempValue: null,
  inputVal: null,
  showHelper: false,
  isFocused: false,
  noBlurValidation: false
});

var _default = Input;
exports["default"] = _default;